import Flickity from 'flickity';

const selectors = {
  slider: '.editorial__slider',
  slide: '.editorial__slide',
  prevArrow: '[data-prev-arrow]',
  nextArrow: '[data-next-arrow]',
  classIsHidden: 'is-hidden',
  dataSlideIndex: 'data-slide-index',
};

const sections = {};

class Editorial {
  constructor(section) {
    this.container = section.container;
    this.slideshow = this.container.querySelector(`${selectors.slider}--${section.id}`);
    this.sliderPrev = this.container.querySelector(selectors.prevArrow);
    this.sliderNext = this.container.querySelector(selectors.nextArrow);
    this.flkty = null;

    this.init();
  }
  init() {
    const self = this;

    if (this.slideshow) {
      this.flkty = new Flickity(this.slideshow, {
        autoPlay: false,
        prevNextButtons: false,
        contain: true,
        pageDots: false,
        adaptiveHeight: true,
        wrapAround: true,
        on: {
          ready: function () {
            const slidesNumber = this.slides.length;
            if (slidesNumber > 1) {
              self.sliderPrev.classList.remove(selectors.classIsHidden);
              self.sliderNext.classList.remove(selectors.classIsHidden);
            } else {
              self.sliderPrev.classList.add(selectors.classIsHidden);
              self.sliderNext.classList.add(selectors.classIsHidden);
            }
          },
        },
      });

      this.sliderPrev.addEventListener('click', function (e) {
        e.preventDefault();

        self.flkty.previous(true);
      });

      this.sliderNext.addEventListener('click', function (e) {
        e.preventDefault();

        self.flkty.next(true);
      });
    }
  }
  onBlockSelect(evt) {
    // Ignore the cloned version
    const slide = this.slideshow.querySelector(`${selectors.slide}--${evt.detail.blockId}`);
    const slideIndex = parseInt(slide.getAttribute(selectors.dataSlideIndex));

    // Go to selected slide, pause autoplay
    this.flkty.select(slideIndex);
    this.flkty.stopPlayer();
  }
}

const editorialSection = {
  onLoad() {
    sections[this.id] = new Editorial(this);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

export default editorialSection;
